import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/components/login.component';
import { SubscriptionReportingApplicationsComponent } from './subscriptions/reporting/components/subscription-reporting-applications.component';
import { SubscriptionSiteTrafficComponent } from './subscriptions/reporting/components/subscription-site-traffic.component';
import { SubscriptionApplicationsComponent } from './subscriptions/applications/components/subscription-applications.component';
import { SubscriptionApplicationDetailsComponent } from './subscriptions/applications/components/subscription-application-details.component';

import { RedemptionReportingApplicationsComponent } from './redemptions/reporting/components/redemptions-reporting-applications.component';
import { RedemptionSiteTrafficComponent } from './redemptions/reporting/components/redemptions-site-traffic.component';
import { RedemptionApplicationsComponent } from './redemptions/applications/components/redemptions-applications.component';
import { RedemptionApplicationDetailsComponent } from './redemptions/applications/components/redemptions-application-details.component';

import { InvestorsComponent } from './investors/components/investors.component';
import { InvestorDetailsComponent } from './investors/components/investor-details.component';
import { DownloadsComponent } from './downloads/components/downloads.component';

const APP_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'subscriptions/reporting/applications',
        component: SubscriptionReportingApplicationsComponent
    },
    {
        path: 'subscriptions/reporting/site-traffic',
        component: SubscriptionSiteTrafficComponent
    },
    {
        path: 'subscriptions/applications',
        component: SubscriptionApplicationsComponent
    },
    {
        path: 'subscriptions/applications/application-details',
        component: SubscriptionApplicationDetailsComponent
    },
    {
        path: 'redemptions/reporting/applications',
        component: RedemptionReportingApplicationsComponent
    },
    {
        path: 'redemptions/reporting/site-traffic',
        component: RedemptionSiteTrafficComponent
    },
    {
        path: 'redemptions/requests',
        component: RedemptionApplicationsComponent
    },
    {
        path: 'redemptions/requests/request-details',
        component: RedemptionApplicationDetailsComponent
    },
    {
        path: 'investors',
        component: InvestorsComponent
    },
    {
        path: 'investors/investor-details',
        component: InvestorDetailsComponent
    },    
    {
        path: 'downloads',
        component: DownloadsComponent
    }
];

export const AppRoutingModule = RouterModule.forRoot(APP_ROUTES, { useHash: true });
